import React from 'react';
import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Επικοινωνία – Weekly Talks</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-8 text-lg">
              Είμαστε εδώ για να σας βοηθήσουμε! Επικοινωνήστε μαζί μας για οποιαδήποτε ερώτηση, πρόταση ή τεχνικό πρόβλημα.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-6">Στοιχεία Επικοινωνίας</h2>
              
              <div className="grid md:grid-cols-2 gap-6">
                {/* Email Contact */}
                <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                  <div className="flex items-center mb-4">
                    <EnvelopeIcon className="w-8 h-8 text-blue-600 mr-3" />
                    <h3 className="text-xl font-semibold text-gray-900">Email</h3>
                  </div>
                  <p className="text-gray-700 mb-3">
                    Για γενικές ερωτήσεις, τεχνική υποστήριξη ή σχόλια:
                  </p>
                  <a 
                    href="mailto:valofocus@gmail.com"
                    className="text-blue-600 hover:text-blue-800 font-medium text-lg underline"
                  >
                    valofocus@gmail.com
                  </a>
                </div>

                {/* Phone Contact */}
                <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
                  <div className="flex items-center mb-4">
                    <PhoneIcon className="w-8 h-8 text-green-600 mr-3" />
                    <h3 className="text-xl font-semibold text-gray-900">Τηλέφωνο</h3>
                  </div>
                  <p className="text-gray-700 mb-3">
                    Για επείγουσες υποθέσεις ή άμεση επικοινωνία:
                  </p>
                  <a 
                    href="tel:+306912345678"
                    className="text-green-600 hover:text-green-800 font-medium text-lg underline"
                  >
                    +30 6986603994
                  </a>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Ώρες Λειτουργίας</h2>
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                <p className="text-gray-700 mb-2">
                  <strong>Δευτέρα - Παρασκευή:</strong> 09:00 - 18:00
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Σάββατο:</strong> 10:00 - 14:00
                </p>
                <p className="text-gray-700">
                  <strong>Κυριακή:</strong> Κλειστά
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Τι μπορούμε να σας βοηθήσουμε;</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Τεχνική υποστήριξη για την εφαρμογή</li>
                <li>Ερωτήσεις σχετικά με τη χρήση των λειτουργιών</li>
                <li>Αναφορές για προβλήματα ή σφάλματα</li>
                <li>Προτάσεις για νέες λειτουργίες</li>
                <li>Γενικές πληροφορίες για το Weekly Talks</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Χρόνος Απάντησης</h2>
              <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                <p className="text-gray-700 mb-2">
                  <strong>Email:</strong> Συνήθως απαντάμε εντός 24 ωρών
                </p>
                <p className="text-gray-700">
                  <strong>Τηλέφωνο:</strong> Άμεση απάντηση κατά τις ώρες λειτουργίας
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
